import { BACKGROUND_COLOR } from './constants';
import { FrameContext } from './frame-canvas';

/**
 * Dip to black: the first half fades `from` out, the second half fades `to` in. `progress` is 0…1; a missing frame
 * (no previous piece, an unreadable first frame) is plain black.
 */
export function drawFadeThroughBlack(
  ctx: FrameContext,
  from: CanvasImageSource | null,
  to: CanvasImageSource | null,
  progress: number,
  width: number,
  height: number,
): void {
  const p = Math.min(1, Math.max(0, progress));
  ctx.globalAlpha = 1;
  ctx.fillStyle = BACKGROUND_COLOR;
  ctx.fillRect(0, 0, width, height);

  const frame = p < 0.5 ? from : to;
  const alpha = p < 0.5 ? 1 - p * 2 : p * 2 - 1;
  if (frame && alpha > 0) {
    ctx.globalAlpha = alpha;
    ctx.drawImage(frame, 0, 0, width, height);
    ctx.globalAlpha = 1;
  }
}
